/* tslint:disable */
/* eslint-disable */
/* @relayHash 033139967051d646125022d08d0192e9 */

import { ConcreteRequest } from "relay-runtime";
export type UpdateSiteBadgesInput = {
    clientMutationId: string;
    siteID: string;
    badges: Array<BadgeRuleInput>;
};
export type BadgeRuleInput = {
    badge: string;
    startDate?: string | null;
    endDate?: string | null;
    isUserSpecific?: boolean | null;
};
export type UpdateSiteBadgeRulesMutationVariables = {
    input: UpdateSiteBadgesInput;
};
export type UpdateSiteBadgeRulesMutationResponse = {
    readonly updateSiteBadges: {
        readonly modifiedCount: number;
        readonly clientMutationId: string;
    };
};
export type UpdateSiteBadgeRulesMutation = {
    readonly response: UpdateSiteBadgeRulesMutationResponse;
    readonly variables: UpdateSiteBadgeRulesMutationVariables;
};



/*
mutation UpdateSiteBadgeRulesMutation(
  $input: UpdateSiteBadgesInput!
) {
  updateSiteBadges(input: $input) {
    modifiedCount
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "UpdateSiteBadgesPayload",
            "kind": "LinkedField",
            "name": "updateSiteBadges",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "modifiedCount",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UpdateSiteBadgeRulesMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UpdateSiteBadgeRulesMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "033139967051d646125022d08d0192e9",
            "metadata": {},
            "name": "UpdateSiteBadgeRulesMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '5f46eebc747962ac7faf9fdac8a8d538';
export default node;
